!function() {
  class t extends HTMLElement {
    constructor() {
      super(), this.shopButton = this.querySelector("[data-shop-button]"), this.isMobile = "ontouchstart" in window && window.innerWidth <= 1024, 
      this.isMobile && this.shopButton && (this.shopButton.classList.add("opacity-0", "pointer-events-none"), 
      this.shopButton.classList.remove("group-hover:flex"), this.addEventListener("touchstart", this.handleTouch.bind(this)));
    }
    handleTouch(t) {
      t.target.closest("[data-shop-button]") || (this.shopButton.classList.contains("opacity-100") ? this.hideButton() : this.showButton());
    }
    showButton() {
      this.shopButton.classList.remove("opacity-0", "pointer-events-none"), this.shopButton.classList.add("opacity-100", "pointer-events-auto");
    }
    hideButton() {
      this.shopButton.classList.remove("opacity-100", "pointer-events-auto"), this.shopButton.classList.add("opacity-0", "pointer-events-none");
    }
  }
  customElements.get("image-grid-touch") || customElements.define("image-grid-touch", t);
}();